export default __webpack_public_path__ + "static/soehne-web-leicht-kursiv-8eab7a8d3df8e6d7d1b2fbbfc5ddbe5e.eot";